import React, {Fragment} from 'react';
import PreBookingInfo from "../Elements/PreBookingInfo";
import {BookingData} from "../Data/BookingData";
import TypeSelect from "../Elements/TypeSelect";
import BookingComplete from "../Elements/BookingComplete/BookingComplete";
import PreOrder from "../Elements/PreOrder/PreOrder";
import TimeSelect from "../Elements/TimeSelect/TimeSelect";
import UserData from "../Elements/UserData";
import moment from 'moment';
import DepositBar from "../Elements/Deposit/DepositBar";
import TermsText from "../Elements/TermsText";
import Button from "../../Form/Element/Button";
import BookingStep from "../../Utility/BookingStep/BookingStep";
import Notice from "../../Utility/Notice/Notice";
import ShortSummary from "../Elements/ShortSummary/ShortSummary";

export default function NyeBooking(props) {
    let booking = props.booking;
    if (booking.is_completed === true) {
        return <BookingComplete booking={props.booking} show_end_time={booking.step < 99}/>
    }
    let minDate = moment().month(11).endOf('month');
    if (booking.step === 1) {
        let can_proceed = props.booking.can_take_booking;
        ['no_people'].map((field) => {
            if (BookingData.getFieldError(field)) {
                can_proceed = false;
            }
            return field;
        });
        return <BookingStep step={1} name="pre-booking-info" type="nye" hot_jar_url="enquiry-info" booking={props.booking}>
            <TypeSelect booking={props.booking} updating={props.updating} nextButton={<Button text="Next" onClick={() => BookingData.update({'step': 2})} disabled={!can_proceed} name="continue"/>}/>
        </BookingStep>
    }
    if (booking.step === 2) {
        let message = 'Oh dear! Looks like we are fully booked on this day. Do you want to try another day?';
        if (props.booking.date && booking.time_slots.length === 0) {
            return <Fragment>
                <BookingStep step={2} name="time-select" type="nye" hot_jar_url="enquiry-availability-none" booking={props.booking}>
                    <Notice name="no-brunch">
                        We can't auto confirm this booking at the moment, would you like to submit an enquiry instead?
                    </Notice>
                    <Button text="Yes" name="do-callback" onClick={() => {
                        BookingData.update({step: 99});
                    }}/>
                </BookingStep>
            </Fragment>
        }
        return <Fragment>
            <BookingStep step={2} name="time-select" type="nye" hot_jar_url="enquiry-availability-check" booking={props.booking}>
                <PreBookingInfo booking={props.booking} updating={props.updating}
                                filterDate={(date) => {
                                    return date.getMonth() === 11 && date.getDate() === 31;
                                }} minDate={minDate} openToDate={minDate.toDate()}
                />
                {props.booking.date && <TimeSelect booking={props.booking} updating={props.updating} show_price={true} stacked={true}
                            show_alternative={true} allow_fallback={false}
                            unavailable_message={message}/>}
            </BookingStep>
        </Fragment>
    }

    if (booking.step === 3) {
        let skip_text = 'Skip';
        if (props.booking.value > 0) {
            skip_text = 'Continue';
        }
        return <Fragment>
            <BookingStep step={3} name="pre-order" type="nye" hot_jar_url="enquiry-pre-orders" booking={props.booking}>
                <PreOrder booking={props.booking}
                          updating={props.updating}
                          intro_text="Sweet, we've added your new years eve page, would you like to change anything?"
                          can_skip={true}
                          skip_text={skip_text}/>
            </BookingStep>
            <DepositBar booking={props.booking} updating={props.updating} next_step={props.next_step}
                        skip_text={'Continue'} can_skip={props.booking.can_last_step}/>
        </Fragment>
    }
    if (booking.step === 4) {
        let skip_text = 'Save Booking';
        if (props.booking.deposit === 0) {
            skip_text = 'Complete Booking';
        }
        return <Fragment>
            <BookingStep step={4} name="user-data" type="nye" hot_jar_url="enquiry-personal-details" booking={props.booking}>
                <h2>Almost Done</h2>
                <ShortSummary booking={props.booking} show_end_time={true}/>
                <UserData booking={props.booking}/>
                <TermsText booking={props.booking}/>
            </BookingStep>
            <DepositBar booking={props.booking} updating={props.updating} next_step={props.next_step}
                        skip_text={skip_text} can_skip={props.booking.can_complete}
                        continueFunction={() => BookingData.completeBooking()}/>
        </Fragment>
    }
    if (booking.step === 99) {
        return <Fragment>
            <BookingStep step={99} name="fallback" type="nye" hot_jar_url="enquiry-fallback-to-callback" booking={props.booking}>
                <UserData booking={props.booking}
                          additional_info={<p>Cool, you want us to help you through your booking? Fill in your details
                              below and we'll get back to you asap!</p>}/>
                <TermsText booking={props.booking}/>
            </BookingStep>
            <DepositBar booking={props.booking} updating={props.updating} next_step={props.next_step}
                        skip_text="Send Enquiry" can_skip={props.booking.can_complete}
                        continueFunction={() => BookingData.completeBooking()}/>
        </Fragment>
    }
    return <BookingStep step={999} name="no-step" type="nye" hot_jar_url="enquiry-error" booking={props.booking}>
        <Notice name="no-step" variant="error">
            Woops something has gone wrong here..
        </Notice>
    </BookingStep>
}